// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"b0-z","subtitle":"c0-z","wrapper":"d0-z","leftArrow":"e0-z","rightArrow":"f0-z"};